export default {
  property_company_name: '中冶置业',
  property_content: `2010年，中冶置业（新加坡）有限公司在新加坡注册成立，负责中冶集团在新加坡及周边地区的房地产开发业务，同时作为股份公司的海外区域性公司，代表股份公司在新加坡开展经营活动。公司连续四年跻身新加坡“十大房地产开发商” 之列，并获得 “亚洲顶尖影响力品牌奖” 以及 “新加坡金字品牌奖全球奖项” 。\n\n中冶置业（新加坡）有限公司已在新加坡独资、合资及管理开发了17个商住综合、私人公寓、执行共管公寓等房地产项目，包括8000余个住宅单位，可售总面积达60多万平方米，在有限的空间里为千万业主“创造无限生活`,
  property_see_all_project: '所有项目',
  property_certificates: 'Qualifications & Certificates',
}